<mat-card>
	<h3>Education System Creation Form
	<button mat-button color="primary"
		[disabled]="resetData.id!==1 && !educationalSystem.valid" (click)="viewIndividualMember()"
		*ngIf="isPageForUpdate">View
		Members/Staff</button>
		 </h3>

<mat-card-content>
<form [formGroup]="educationalSystem" (ngSubmit)="onSubmit()">
	
	<mat-error *ngIf="formDataInvalid"> 
	One of mandatory data is missing
	</mat-error>
	<mat-error *ngIf="message"> 
	{{message}}
	</mat-error>
	<mat-form-field [style.display]="'none'" class="full-width-input">
        <input matInput placeholder="Id" formControlName="id">
    </mat-form-field>
	<mat-form-field class="full-width-input spacing-field">
        <input matInput placeholder="College Name" formControlName="name" required>
        <mat-error>
          Invalid College Name
        </mat-error>
        <mat-hint>Min 6, Max 80 char</mat-hint>
      </mat-form-field>
      <mat-form-field class="full-width-input spacing-field">
        <input matInput placeholder="Subsidery Name" formControlName="subName">
        <mat-error>
          Please provide a valid Subsidery Name
        </mat-error>
        <mat-hint>Max 30 char</mat-hint>
      </mat-form-field>
      <mat-form-field class="full-width-input spacing-field">
        <input matInput placeholder="College Nick Name" formControlName="nickName">
        <mat-error>
          Please provide a valid Nick Name
        </mat-error>
        <mat-hint>Max 30 char</mat-hint>
      </mat-form-field>
      <mat-form-field class="full-width-input spacing-field">
        <input matInput placeholder="Registration Number/Id" formControlName="registrationNo" required>
        <mat-error>
          Please provide a valid Registration Number/Id
        </mat-error>
        <mat-hint>Min 6, Max 30 char</mat-hint>
      </mat-form-field>
	<div formGroupName="affiliatedBy">
		<mat-form-field [style.display]="'none'" class="full-width-input spacing-field"> <input
			matInput placeholder="Affiliate By" formControlName="id">
		<mat-error> Please provide a valid Affiliation Detail </mat-error> 
		<mat-hint>Min 2, Max 75 char</mat-hint>
		</mat-form-field>
		
		<mat-form-field class="full-width-input spacing-field"> <input matInput placeholder="Affiliate By"
				formControlName="value" [matAutocomplete]="auto" required>
			<mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="onAutoCompleteSelection($event)">
				<mat-option *ngFor="let option of affiliatedByFilteredOptions  | async " [value]="option.id" (onSelectionChange)="onSelectOfAffiliatedByOption($event)">
					{{option.value}}
				</mat-option>
			</mat-autocomplete>
			<mat-error> Please provide a valid Affiliation Detail </mat-error>
			<mat-hint>Min 2, Max 75 char</mat-hint>
		</mat-form-field>
	</div>
	
	<!-- <mat-form-field class="full-width-input"> <input
		matInput placeholder="Educational System Type"
		formControlName="educationalSystemTypeStr" required> <mat-error>
	Please provide a valid Educational System Type</mat-error> </mat-form-field> -->
	
	<mat-form-field>
	  <!-- <mat-label>Educational System Type</mat-label> -->
	  <mat-select formControlName="educationalSystemTypeStr"  placeholder="Educational System Type"  required>
	    <mat-option></mat-option>
	    <mat-option [value]="companyType.key" *ngFor="let companyType of appData.companyTypes | keyvalue">{{ companyType.value }}</mat-option>
	  </mat-select>
	  <mat-error> Please select a valid Educational System Type</mat-error>
	</mat-form-field>
	
	&nbsp;
	<mat-form-field  *ngIf="submitBtnName == 'Update'" class="full-width-input spacing-field">
	  <!--<mat-label>Inherited calendar color</mat-label>-->
	  <input matInput [matDatepicker]="picker1" placeholder="Expiry Date" formControlName="expiryDate" 
	  	[min]="todayDateFilter" [matDatepickerFilter]="customDateFilter">
	  <mat-hint>MM/DD/YYYY</mat-hint>
	  <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
	  <mat-datepicker #picker1 color="primary"></mat-datepicker>
	</mat-form-field>
	
	
	<fieldset>
	  <legend>
		  <h3>Address
		  </h3>
	  </legend> 
	  
	<div formGroupName="address">
		
      <mat-form-field [style.display]="'none'" class="full-width-input">
        <input matInput placeholder="Id" formControlName="id">
  	  </mat-form-field>
      <mat-form-field class="full-width-input spacing-field">
        <input matInput placeholder="Address Line 1" formControlName="addressLine1" required>
        <mat-error>
          Please provide a valid Address
        </mat-error>
        <mat-hint>Min 5, Max 50 char</mat-hint>
      </mat-form-field>
      <mat-form-field class="full-width-input spacing-field">
        <input matInput placeholder="Address Line 2" formControlName="addressLine2" required>
        <mat-error>
          Please provide a valid Address
        </mat-error>
        <mat-hint>Min 5, Max 50 char</mat-hint>
      </mat-form-field>
            <mat-form-field class="full-width-input spacing-field">
        <input matInput placeholder="City" formControlName="city" required>
        <mat-error>
          Please provide a valid City
        </mat-error>
        <mat-hint>Min 2, Max 30 char</mat-hint>
      </mat-form-field>
            <mat-form-field class="full-width-input spacing-field">
        <input matInput placeholder="State" formControlName="state" required>
        <mat-error>
          Please provide a valid State
        </mat-error>
        <mat-hint>Min 2, Max 20 char</mat-hint>
      </mat-form-field>
      <mat-form-field class="full-width-input spacing-field">
        <input matInput placeholder="Country" formControlName="country" required>
        <mat-error>
          Please provide a valid Country
        </mat-error>
        <mat-hint>Min 2, Max 50 char</mat-hint>
      </mat-form-field>
      <mat-form-field class="full-width-input spacing-field">
        <input matInput placeholder="Pin Code/Zip Code" formControlName="pinCode" required>
        <mat-error>
          Please provide a Pin Code / Zip Code
        </mat-error>
        <mat-hint>Min 5 char</mat-hint>
      </mat-form-field>
	</div>
	</fieldset>
	
	
	
	<div formGroupName="owner">
	<fieldset>
	  <legend>
		  <h3>Educational System Owner Detail</h3>
	  </legend> 	
      <mat-form-field [style.display]="'none'" class="full-width-input spacing-field">
        <input matInput placeholder="Id" formControlName="id">
  	  </mat-form-field>
      <mat-form-field class="full-width-input spacing-field">
        <input matInput placeholder="First Name" formControlName="firstName" required>
        <mat-error>
          Please provide a valid First Name
        </mat-error>
        <mat-hint>Max 50 char</mat-hint>
      </mat-form-field>
      <mat-form-field class="full-width-input spacing-field">
        <input matInput placeholder="Middle Name" formControlName="middleName">
        <mat-error>
          Please provide a valid Middle Name
        </mat-error>
        <mat-hint>Max 50 char</mat-hint>
      </mat-form-field>
      <mat-form-field class="full-width-input spacing-field">
        <input matInput placeholder="Last Name" formControlName="lastName" required>
        <mat-error>
          Please provide a valid Last Name
        </mat-error>
        <mat-hint>Max 50 char</mat-hint>
      </mat-form-field>
		<mat-form-field class="full-width-input spacing-field">
		  <!-- <mat-label>Individual Type</mat-label> -->
		  <mat-select formControlName="individualTypeStr"  placeholder="Individual Type"  required>
		    <mat-option></mat-option>
		    <mat-option [value]="individualType.key" *ngFor="let individualType of appData.individualTypes | keyvalue">{{ individualType.value }}</mat-option>
		  </mat-select>
		  <mat-error> Please select Individual Type</mat-error>
		</mat-form-field>
		<mat-form-field class="full-width-input">
        <input matInput placeholder="Login Id" formControlName="loginUserId" required>
        <mat-error>
          Invalid User Id
        </mat-error>
      	<mat-hint>Min 8, Max 50 char</mat-hint>
      	</mat-form-field>
      	</fieldset>
      	
      	
      	<h4>Roles ( {{roleList.selectedOptions.selected.length}} Selected )</h4>
		<mat-selection-list class="mat-selection-list-frame" formControlName="roleList"  placeholder="Role List" required  #roleList>
		  <mat-list-option [value]="role.id" *ngFor="let role of appData.allRoles.value ">
		    {{role.id}}
		     <mat-divider></mat-divider>
		  </mat-list-option>
		  <!-- <mat-error> Please select at least one Role</mat-error> -->
		</mat-selection-list>
	</div>
</form>
<p></p>
<button mat-raised-button color="primary" [disabled]="!educationalSystem.valid"  (click)="onSubmit()">{{submitBtnName}}</button>
&nbsp;<button mat-raised-button color="primary" (click)="clearEducationSystem()">Reset</button>


</mat-card-content> </mat-card>
